

export function getImageSize(url: string): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      
      img.onerror = (error) => {
        reject(new Error("Failed to load image"));
      };
  
      img.src = url;
    })
}

export async function getImageSizeFromFile(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const img = new Image();
   
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          img.src = reader.result;  
        }
      };
   
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
  
      img.onerror = (error) => {
        reject(new Error("Failed to load image"));
      };
  
      reader.onerror = (error) => {
        reject(new Error("Failed to read file"));
      };
  
      reader.readAsDataURL(file); 
    });
  }
/**
 * Points an image url at the pre-generated .webp sibling, when one exists.
 *
 * Only this site's own uploads have that sibling: the upload pipeline writes a `webp/`
 * folder next to each image under /filesystem/. Applying the rewrite to any other url
 * invents a path that was never created - which is what turned every picture on an
 * imported product into a "No Photo" placeholder, because those are marketplace urls
 * served from the source's CDN and rewriting them 404s.
 *
 * Remote urls are returned untouched, so they load as-is.
 */
export function toWebpImageUrl(imageUrl: string): string {
    if (!imageUrl) { return ''; }

    // Our own files, whether referenced absolutely or relatively, always sit under
    // /filesystem/. Anything else belongs to somebody else's server.
    if (imageUrl.indexOf('/filesystem/') < 0) { return imageUrl; }

    const fileName = imageUrl.split('/').pop();
    const convertible = /\.(jpg|jpeg|png|bmp|tiff)$/i;

    if (fileName && convertible.test(fileName)) {
        return imageUrl.replace(fileName, `webp/${fileName.replace(convertible, '.webp')}`);
    }

    return imageUrl;
}
